import styles from "./SecondScreen.module.css"
import image1 from "../images/ממומן תוצאות.webp"
import image2 from "../images/נתוני חשיפה.webp"
import Button from "../components/button/Button"
import RecommendsScreen from "../components/RecommendsScreen/RecommendsScreen"
import StatsShowcase from "../components/CountupWrapper/Count"
import ShortsRec from "../components/shortsRec/Shorts"
const SecondScreen=()=>{


return <>

<div className={styles.description}>לפני שנמשיך לדבר..</div>

<div className={styles.title}> זמן <div className={styles.titleHighlight}>תוצאות</div></div>
          <div className={styles.imageContainer}>
              <img className={styles.image} src={image2}/>
            </div>
     <div className={styles.imageContainer}>
              <img className={styles.image} src={image1}/>
            </div>

          
            <Button text="נטלי, בואי נדבר!"/>
   <div className={styles.title}>והתגובות של הלקוחות..?</div>
   <ShortsRec/>
   <RecommendsScreen/>
<StatsShowcase 
  title="בואו ניתן למספרים לדבר" 
  highlightedWord="לדבר" 
/>
<div className={styles.title}> אז למה שבכלל <div className={styles.titleHighlight}>תקשיבו לי?</div></div>
</>


}
export default SecondScreen